import $ from 'jquery';

$(document).ready(function () {
  if (window.location.hash) {
    var hash = window.location.hash.substring(1);
    var element = $(`#${hash}`).closest('.category-element');
    
    setTimeout(function () {
      element.addClass('highlighted');
    }, 300);

    setTimeout(function () {
      element.removeClass('highlighted');
    }, 1500);
  }
});
